import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openRenewSubscriptionModal = ({ onClose, ...data }) =>
    openPopupHelper({ popupName: popupNames.RENEW_SUBSCRIPTION_MODAL, data, onClose });
